/**
 * Creates a combined field name from a namespace and a field name
 *
 * @param fieldName
 * @param namespace
 */
export var withNamespace = function withNamespace(fieldName, namespace) {
    return namespace ? namespace + "." + fieldName : fieldName;
};
